export const ADMIN = 'manager';
export const INTEL_PRODUCER = 'user';
export const INTEL_CONSUMER = 'viewer';
